"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const useStyles = (0, makeStyles_1.default)((theme) => ({
    title: {
        fontSize: "1.5rem",
    },
    box: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: "209px",
        boxSizing: "border-box",
        textShadow: "0.01em 0 rgba(0, 0, 0, 0.2),0 0.01em rgba(0, 0, 0, 0.2),-0.01em 0 rgba(0, 0, 0, 0.2),0 -0.01em rgba(0, 0, 0, 0.2)",
    },
    shrinkBox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: "60px",
        display: "flex",
        alignItems: "center",
    },
}));
function ShrinkingTitle({ title, variant, }) {
    const [fade, setFade] = (0, react_1.useState)(false);
    const [animate, setAnimate] = (0, react_1.useState)(true);
    const [collapsed, setCollapsed] = (0, react_1.useState)(false);
    const classes = useStyles();
    (0, react_1.useEffect)(() => {
        setAnimate(false);
    }, []);
    const onCollapsed = () => {
        setCollapsed(true);
        setFade(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !collapsed && (react_1.default.createElement(material_1.Collapse, { in: animate, collapsedSize: 60, onExited: onCollapsed },
            react_1.default.createElement(material_1.Box, { className: classes.box, pr: 8, pl: 8, pt: 8, pb: 8 }))),
        collapsed && (react_1.default.createElement(material_1.Box, { className: classes.shrinkBox, pr: 8, pl: 8 },
            react_1.default.createElement(material_1.Fade, { in: fade, timeout: 200 },
                react_1.default.createElement(material_1.Typography, { className: classes.title, variant: "h1" }, title))))));
}
exports.default = ShrinkingTitle;
